import { Link } from "react-router-dom";
import CustomTitle from '../CustomMiscellaneous/CustomTitle';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { toast } from "react-hot-toast";
import LogoutIcon from '@mui/icons-material/Logout';
import Notifications from '../Notifications/Notifications';
import { palette } from '../../assets/theme/theme';
import { useState } from "react";
import HorizontalRule from "../HorizontalRule/HorizontalRule";
import { userIsAdmin } from "../../utils/UserInfoHandler";


const horizontalRuleStyle = { marginRight: 20, marginLeft: 20, color: 'white', opacity: 0.7 };

export default function ActionButtons({ setUser, navbarOpen, setUserInfo, cancelSelectedRoute }: any) {


    const buttonStyle = `content-center justify-center cursor-pointer p-1 bg-rodrimaq-red-dark text-white rounded-md hover:text-rodrimaq-red-dark hover:bg-white ${!navbarOpen ? 'my-1':''}`

    return (<>
        
        <div className={`${navbarOpen ? 'flex px-2 py-2' : 'block px-8 py-2'} justify-around bg-rodrimaq-red-medium rounded-md shadow-md`} >

            <Notifications  />

            <Link to={"/utilizadores"}>
                <div className={buttonStyle} onClick={cancelSelectedRoute}>
                    <AccountCircleIcon />
                </div>
            </Link>
            {userIsAdmin() ? <Link to={"/configurations"}>
                <div className={`${buttonStyle}`} onClick={cancelSelectedRoute}>
                    <SettingsIcon  />
                </div>
            </Link> : null}

            <Link to={"/"}>
                <div className={buttonStyle} onClick={cancelSelectedRoute}>
                    <LogoutIcon onClick={() => { setUser(null); setUserInfo(null) }} />
                </div>
            </Link>
        </div>
       

    </>
    )


}